import { ReactNode } from "react";

import { cx } from "@/utils";

import styles from "./Adornment.module.css";

/**
 * Adornment is used together with Inputs to add for example an icon or a currency inside of it.
 * Example:
 * <Input startAdornment={
 *    <Adornment position="start">
 *       <SearchIcon/>
 *    </Adornment>
 * }/>
 */
interface AdornmentProps extends React.HTMLProps<HTMLSpanElement> {
  children?: ReactNode;
  position?: "start" | "end";
  clickthrough?: boolean;
  className?: string;
}
const Adornment: React.FunctionComponent<AdornmentProps> = ({
  position = "end",
  clickthrough = true,
  children,
  className,
  ...props
}) => {
  return (
    <span
      {...props}
      className={cx(
        styles.root,
        {
          [styles.start]: position === "start",
          [styles.end]: position === "end",
          [styles.clickthrough]: clickthrough,
        },
        className
      )}
    >
      {children}
    </span>
  );
};

export default Adornment;
